// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `qr-drop-down drop-down-menu .qr-guide-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 849px;
  height: 100%;
  margin: 0 auto;
}
qr-drop-down drop-down-menu .qr-guide-container .guide {
  width: 585px;
}
qr-drop-down drop-down-menu .qr-guide-container .guide h1 {
  font-size: 55px;
  line-height: 64px;
  margin-top: -12px;
}
qr-drop-down drop-down-menu .qr-guide-container .guide p:last-child {
  margin-bottom: 0;
}
qr-drop-down drop-down-menu .qr-guide-container canvas {
  height: 233px;
}
qr-drop-down drop-down-menu .drop-down-menu.open {
  height: 50vh;
}
qr-drop-down drop-down-menu .drop-down-menu.open .drawer-content {
  padding-top: var(--header-height);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/qr-drop-down/qr-drop-down.component.scss"],"names":[],"mappings":"AAIQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAHZ;AAKY;EACI,YAAA;AAHhB;AAKgB;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;AAHpB;AAMgB;EACI,gBAAA;AAJpB;AAQY;EACI,aAAA;AANhB;AAkBQ;EACI,YAAA;AAhBZ;AAkBY;EACI,iCAAA;AAhBhB","sourcesContent":["qr-drop-down {\n\n    drop-down-menu {\n\n        .qr-guide-container {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 849px;\n            height: 100%;\n            margin: 0 auto;\n\n            .guide {\n                width: 585px;\n\n                h1 {\n                    font-size: 55px;\n                    line-height: 64px;\n                    margin-top: -12px;\n                }\n\n                p:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            canvas {\n                height: 233px;\n            }\n\n            // &.tall {\n            //     width: 900px;\n\n            //     canvas {\n            //         height: 283px;\n            //     }\n            // }\n        }\n\n        .drop-down-menu.open {\n            height: 50vh;\n\n            .drawer-content {\n                padding-top: var(--header-height);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
